import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

interface PagenationProps {
  listAllLength: number | undefined;
  listLimit: number | undefined;
  onCurrentPageChange: (value: number) => void;
}

const Pagenation = ({
  listAllLength,
  listLimit,
  onCurrentPageChange,
}: PagenationProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(Number(listAllLength) / Number(listLimit));

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    onCurrentPageChange(pageNumber);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [listLimit, listAllLength]);

  const startPage = Math.floor((currentPage - 1) / 10) * 10 + 1; // 현재 페이지를 기준으로 시작 페이지
  const endPage = Math.min(startPage + 9, totalPages); // 10 페이지까지 표시하지만 totalPages를 넘지 않도록

  return (
    <>
      <Box className="flex jcc aic">
        <div className="arrow-box flex">
          <button
            className="arrow-btn img-box"
            type="button"
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          >
            <img src="/img/arrow_prev_double_949494.svg" />
          </button>
          <button
            className="arrow-btn img-box"
            type="button"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <img src="/img/arrow_prev_949494.svg" />
          </button>
        </div>
        <NumBox>
          {[...Array(endPage - startPage + 1)].map((_, index) => {
            const pageNumber = startPage + index;
            return (
              <li
                key={pageNumber}
                className={currentPage === pageNumber ? 'active' : ''}
                onClick={() => handlePageChange(pageNumber)}
              >
                {pageNumber}
              </li>
            );
          })}
        </NumBox>
        <div className="arrow-box flex">
          <button
            className="arrow-btn img-box"
            type="button"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <img src="/img/arrow_next_949494.svg" />
          </button>
          <button
            className="arrow-btn img-box"
            type="button"
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          >
            <img src="/img/arrow_next_double_949494.svg" />
          </button>
        </div>
      </Box>
    </>
  );
};

export default Pagenation;

export const Box = styled.div<{ $miniSize?: boolean }>`
  margin-top: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  .arrow-box {
    gap: 4px;
    button {
      width: 20px;
      &:disabled {
        opacity: 0;
        cursor: inherit;
      }
    }
  }
`;

export const NumBox = styled.ul`
  display: flex;
  gap: 4px;
  > li {
    width: 30px;
    height: 30px;
    border-radius: 2px;
    border: 1px solid #D9D9D9;
    background: #fff;
    color: #949494;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &.active {
        background: ${props => props.theme.mainColor1};
        color: #fff;
    }
  }
`;
